module.exports = __webpack_public_path__ + "media/Video 124.ad457b7c.mp4";